export const formatDateTime = (value: string | number): string => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return String(value);

  // Desired format: 10th August 2025, 10:20 PM
  const getOrdinalSuffix = (d: number) => {
    const j = d % 10,
      k = d % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
  };

  const day = date.getDate();
  const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
  const monthName = new Intl.DateTimeFormat("en-GB", { month: "long" }).format(
    date,
  );
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert to 12-hour format, with 12 for midnight/noon
  const minutesStr = String(minutes).padStart(2, "0");

  return `${dayWithSuffix} ${monthName} ${year}, ${hours}:${minutesStr} ${period}`;
};

// Helper: Title-case a string (capitalize each word) with fallback
export const getCapitalizeString = (value?: string) => {
  const v = (value ?? "this title").trim();
  return v.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase(),
  );
};

/**
 * Builds a query string for API calls.
 */
export const buildQueryParams = (config: Record<string, unknown>): string => {
  const params = new URLSearchParams();

  Object.entries(config).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });

  return params.toString();
};

export const getActionPermission = (action) => {
  return action.key === "EDIT"
    ? "update"
    : action.key === "DUPLICATE"
      ? "create"
      : action.key === "DELETE"
        ? "delete"
        : "read";
};
